import type { PartnerProgramDto } from '@upme/contracts';
import { formatPartnerReward, partnerRewardLocal } from '@upme/view-logic';

interface Props {
  program: PartnerProgramDto;
  price: number | null;
  currency: string;
}

/** Партнёрская программа события — только чтение: менять её может лишь организатор (#164). */
export function EventPartnerProgramCard({ program, price, currency }: Props) {
  return (
    <section className="rounded-lg border bg-card p-4 space-y-3">
      <h2 className="text-sm font-semibold">Партнёрская программа</h2>

      <dl className="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 text-sm">
        <dt className="text-muted-foreground">Процент</dt>
        <dd className="tabular-nums">{program.rewardPercent}%</dd>

        <dt className="text-muted-foreground">Награда</dt>
        <dd className="tabular-nums">
          {formatPartnerReward(
            {
              energy: program.rewardEnergy,
              usdCents: program.rewardUsdCents,
              local: partnerRewardLocal(price, program.rewardPercent, currency),
            },
            'ru',
          )}
        </dd>

        <dt className="text-muted-foreground">Места</dt>
        <dd className="tabular-nums">
          {program.seatsTaken} из {program.seatsLimit}
        </dd>

        {program.poolRemainingEnergy !== null ? (
          <>
            <dt className="text-muted-foreground">В пуле</dt>
            <dd className="tabular-nums">{program.poolRemainingEnergy} ⚡</dd>
          </>
        ) : null}
      </dl>
    </section>
  );
}
